import request from "@/api/request";

//充值顺序
export function sortCard(value) {
  return request({
    url: `/app/simCard/sort?card=${value}`,
  });
}

//检测卡是否存在
export function getByCard(value) {
  return request({
    url: `/app/cardSave/getByCard?card=${value}`,
  });
}

//根据手机号查找卡号
export function phoneQuery(value) {
  return request({
    url: `/app/realname/phoneQuery?phone=${value}`,
  });
}
